module.exports = __webpack_public_path__ + "img/empty-archive-boards.29c73e2e.svg";